import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * VetSearch - Redirects to Marketplace with veterinari filter
 * This page is now unified with Marketplace
 */
export default function VetSearch() {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to marketplace with veterinari filter
    navigate('/marketplace?filter=veterinario', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center">
      <div className="text-center">
        <p className="text-[#86868B]">Reindirizzamento...</p>
      </div>
    </div>
  );
}
